module.exports = __webpack_public_path__ + "static/media/Exit-White.ee05786a.svg";